import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  border: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;
const DividerDiv = styled.div`
  padding: 16px 0 0;
  border-top: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const BorderDiv = styled.div`
  border-top: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const RewardDiv = styled.div`
  width: 60%;
  padding: 12px 20px;
  border-right: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const PointsDiv = styled.div`
  width: 60%;
  padding: 20px;
  border-right: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const ExpiryDiv = styled.div`
  width: 40%;
  padding: 14px 32px;
`;
const ValidityDiv = styled.div`
  width: 40%;
  padding: 20px 32px;
`;

const XoxoPointRewardBody = ({
  validTill,
  isDesktopPreview,
  platformSetting,
}) => {
  return (
    <>
      {isDesktopPreview ? (
        <StyledDiv className="xoxo-point-reward-body-desktop d-flex">
          <div className="d-flex align-items-center">
            <RewardDiv>
              <Typography.HelperText color="dark" shade="c200">
                Your reward
              </Typography.HelperText>
            </RewardDiv>
            <ExpiryDiv>
              <Typography.HelperText color="dark" shade="c200">
                Expires on
              </Typography.HelperText>
            </ExpiryDiv>
          </div>
          <BorderDiv />
          <div className="d-flex align-items-center">
            <PointsDiv>
              <Typography.H3 color="dark" shade="c300">
                *****
                {platformSetting?.customText?.empulsPoints ||
                  "Xoxo Reward Points"}
              </Typography.H3>
            </PointsDiv>
            <ValidityDiv>
              <Typography color="dark" shade="c300" className="mb-0">
                {validTill}
              </Typography>
            </ValidityDiv>
          </div>
          <div></div>
        </StyledDiv>
      ) : (
        <StyledDiv className="xoxo-point-reward-body">
          <div className="d-flex align-items-center">
            <Typography.HelperText color="dark" shade="c200">
              Your reward
            </Typography.HelperText>
          </div>
          <div className="d-flex align-items-center">
            <Typography color="dark" shade="c300">
              *****{platformSetting?.customText?.empulsPoints || "Xoxo Reward Points"}
            </Typography>
          </div>
          <DividerDiv></DividerDiv>
          <div className="d-flex align-items-center">
            <Typography.HelperText color="dark" shade="c200">
              Expires on
            </Typography.HelperText>
          </div>
          <div className="d-flex align-items-center">
            <Typography color="dark" shade="c300" className="mb-0">
              {validTill}
            </Typography>
          </div>
        </StyledDiv>
      )}
    </>
  );
};

export default XoxoPointRewardBody;
